@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package truematchmp.composeapp.generated.resources

import kotlin.OptIn
import org.jetbrains.compose.resources.DrawableResource

private object CommonMainDrawable0 {
  public val ai_slogan: DrawableResource by 
      lazy { init_ai_slogan() }

  public val background: DrawableResource by 
      lazy { init_background() }

  public val coming_soon: DrawableResource by 
      lazy { init_coming_soon() }

  public val connect_slogan: DrawableResource by 
      lazy { init_connect_slogan() }

  public val facebook_logo_white: DrawableResource by 
      lazy { init_facebook_logo_white() }

  public val focus_slogan: DrawableResource by 
      lazy { init_focus_slogan() }

  public val games_slogan: DrawableResource by 
      lazy { init_games_slogan() }

  public val google_color: DrawableResource by 
      lazy { init_google_color() }

  public val ic_android_black_24dp: DrawableResource by 
      lazy { init_ic_android_black_24dp() }

  public val ic_ios: DrawableResource by 
      lazy { init_ic_ios() }

  public val logo_no_background_glow: DrawableResource by 
      lazy { init_logo_no_background_glow() }

  public val tasty_cashback: DrawableResource by 
      lazy { init_tasty_cashback() }
}

internal val Res.drawable.ai_slogan: DrawableResource
  get() = CommonMainDrawable0.ai_slogan

private fun init_ai_slogan(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ai_slogan",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/drawable/ai_slogan.webp", -1, -1),
    )
)

internal val Res.drawable.background: DrawableResource
  get() = CommonMainDrawable0.background

private fun init_background(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:background",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/drawable/background.webp", -1, -1),
    )
)

internal val Res.drawable.coming_soon: DrawableResource
  get() = CommonMainDrawable0.coming_soon

private fun init_coming_soon(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:coming_soon",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/drawable/coming_soon.xml", -1, -1),
    )
)

internal val Res.drawable.connect_slogan: DrawableResource
  get() = CommonMainDrawable0.connect_slogan

private fun init_connect_slogan(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:connect_slogan",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/drawable/connect_slogan.webp", -1, -1),
    )
)

internal val Res.drawable.facebook_logo_white: DrawableResource
  get() = CommonMainDrawable0.facebook_logo_white

private fun init_facebook_logo_white(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:facebook_logo_white",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/drawable/facebook_logo_white.xml", -1, -1),
    )
)

internal val Res.drawable.focus_slogan: DrawableResource
  get() = CommonMainDrawable0.focus_slogan

private fun init_focus_slogan(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:focus_slogan",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/drawable/focus_slogan.webp", -1, -1),
    )
)

internal val Res.drawable.games_slogan: DrawableResource
  get() = CommonMainDrawable0.games_slogan

private fun init_games_slogan(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:games_slogan",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/drawable/games_slogan.webp", -1, -1),
    )
)

internal val Res.drawable.google_color: DrawableResource
  get() = CommonMainDrawable0.google_color

private fun init_google_color(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:google_color",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/drawable/google_color.xml", -1, -1),
    )
)

internal val Res.drawable.ic_android_black_24dp: DrawableResource
  get() = CommonMainDrawable0.ic_android_black_24dp

private fun init_ic_android_black_24dp(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_android_black_24dp",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/drawable/ic_android_black_24dp.xml", -1, -1),
    )
)

internal val Res.drawable.ic_ios: DrawableResource
  get() = CommonMainDrawable0.ic_ios

private fun init_ic_ios(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_ios",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/drawable/ic_ios.xml", -1, -1),
    )
)

internal val Res.drawable.logo_no_background_glow: DrawableResource
  get() = CommonMainDrawable0.logo_no_background_glow

private fun init_logo_no_background_glow(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:logo_no_background_glow",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/drawable/logo_no_background_glow.webp", -1, -1),
    )
)

internal val Res.drawable.tasty_cashback: DrawableResource
  get() = CommonMainDrawable0.tasty_cashback

private fun init_tasty_cashback(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:tasty_cashback",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/drawable/tasty_cashback.webp", -1, -1),
    )
)
